import { render } from "./MenuDown.vue?vue&type=template&id=53962b0a"
import script from "./MenuDown.vue?vue&type=script&lang=js"
export * from "./MenuDown.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__